import { withDevtools, withGlitchTracking, withStorageSync } from '@angular-architects/ngrx-toolkit';
import {
  ENGINE_REPORT_STORE_ID,
  EngineReportState,
  INITIAL_ENGINE_REPORT_STATE,
} from '@navstation-portal/reporting/data-model/engine-report';
import { signalStore, withState } from '@ngrx/signals';
import { withEngineReportComputed } from './with-engine-report-computed';
import { withEngineReportEffects } from './with-engine-report-effects';
import { withEngineReportReducer } from './with-engine-report-reducer';

type PersistedEngineReportState = Pick<EngineReportState, 'report' | 'localReportId' | 'reportType'>;

// Draft reports live only in this store until submitted, so a refresh must not lose what's
// been entered. reportFrom/reportTo round-trip through JSON as strings and need reviving.
function reviveEngineReportDetailDates(state: PersistedEngineReportState): PersistedEngineReportState {
  const report = state.report;
  if (!report) return state;

  return {
    ...state,
    report: {
      ...report,
      details: {
        ...report.details,
        reportFrom: report.details.reportFrom ? new Date(report.details.reportFrom) : undefined,
        reportTo: report.details.reportTo ? new Date(report.details.reportTo) : undefined,
      },
    },
  };
}

export const EngineReportStore = signalStore(
  { providedIn: 'root' },
  withDevtools(ENGINE_REPORT_STORE_ID, withGlitchTracking()),
  withState<EngineReportState>(INITIAL_ENGINE_REPORT_STATE),
  withStorageSync({
    key: ENGINE_REPORT_STORE_ID,
    select: (state: EngineReportState) => ({
      report: state.report,
      localReportId: state.localReportId,
      reportType: state.reportType,
    }),
    parse: (stateString) => reviveEngineReportDetailDates(JSON.parse(stateString)) as EngineReportState,
  }),
  withEngineReportEffects(),
  withEngineReportReducer(),
  withEngineReportComputed()
);
